import { deepmerge } from './utils'

export class DataRevision {
  currentGroup = ''
  groups = {}
  maxRevision = 10

  constructor (maxRevision = 10, currentGroup = '') {
    this.maxRevision = maxRevision
    this.currentGroup = currentGroup
  }

  get current () {
    const groupKey = this.currentGroup
    return this.get(groupKey)
  }

  useGroup (groupKey = this.currentGroup) {
    this.currentGroup = groupKey
    return this
  }

  setMaxRevision (maxRevision) {
    this.maxRevision = maxRevision
    return this
  }

  reset () {
    this.groups = {}
    return this
  }

  add (data, groupKey = this.currentGroup) {
    if (!this.groups.hasOwnProperty(groupKey)) this.groups[groupKey] = []
    this.groups[groupKey].push(data)
    this.groups[groupKey] = this.groups[groupKey].slice(-this.maxRevision)
    return this
  }

  remove (data, groupKey = this.currentGroup) {
    if (this.groups.hasOwnProperty(groupKey)) {
      const index = this.groups[groupKey].indexOf(data)
      if (index >= 0) {
        this.groups[groupKey].splice(index, 1)
        if (this.groups[groupKey].length === 0) delete this.groups[groupKey]
      }
    }
    return this
  }

  rollback (groupKey = this.currentGroup) {
    const latestData = this.get(groupKey)
    this.remove(latestData, groupKey)
    return this
  }

  get (groupKey = this.currentGroup) {
    if (this.groups.hasOwnProperty(groupKey)) {
      return this.groups[groupKey].slice(-1)[0]
    }
  }

  getMergedDataGroup (groupKey = this.currentGroup, mergeData = {}) {
    return deepmerge(
      ...Object.keys(this.groups).map(k => this.get(k)),
      this.get(groupKey),
      mergeData
    )
  }
}
